module.exports = __webpack_public_path__ + "static/img/business_no_data.18275474.svg";